import { useEffect, useRef, useState } from "react";
import { Camera, ImagePlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fileUrl, uploadFile } from "@/lib/upload";
import { useAuth } from "@/context/AuthContext";
import { Avatar } from "@/components/common";

export function Cover({ fileId, className = "" }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    setUrl(null);
    if (fileId) fileUrl(fileId).then(setUrl).catch(() => {});
  }, [fileId]);
  return (
    <div className={`relative w-full overflow-hidden bg-mr-raised ${className}`} data-testid="profile-cover">
      {url ? <img src={url} alt="" className="w-full h-full object-cover" />
        : <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,color-mix(in_srgb,var(--mr-accent)_35%,transparent),transparent_60%)]" />}
    </div>
  );
}

export function ProfileMedia() {
  const { me, refresh } = useAuth();
  const photoRef = useRef(null);
  const coverRef = useRef(null);
  const [busy, setBusy] = useState("");
  const pick = async (field, file) => {
    if (!file) return;
    setBusy(field);
    try {
      const id = await uploadFile("photo", file);
      await api.patch("/me/profile", { [field]: id });
      await refresh();
      toast.success(field === "photo_file_id" ? "Photo de profil mise à jour" : "Image de couverture mise à jour");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };
  return (
    <div className="mr-card p-0 overflow-hidden" data-testid="profile-media-editor">
      <div className="relative">
        <Cover fileId={me.profile?.cover_file_id} className="h-28 sm:h-36" />
        <button type="button" data-testid="profile-cover-button" disabled={!!busy} onClick={() => coverRef.current.click()} className="absolute top-3 right-3 mr-btn-secondary h-9 px-3 text-xs bg-mr-surface/90"><ImagePlus size={14} /> {busy === "cover_file_id" ? "Envoi…" : "Couverture"}</button>
      </div>
      <div className="px-5 pb-5 -mt-10 flex items-end gap-4">
        <button type="button" data-testid="profile-photo-button" disabled={!!busy} onClick={() => photoRef.current.click()} className="relative z-10 rounded-full ring-4 ring-mr-surface group" aria-label="Changer la photo de profil">
          <Avatar name={me.user.name} fileId={me.user.photo_file_id} size={84} />
          <span className="absolute inset-0 rounded-full bg-black/45 text-white grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity"><Camera size={18} /></span>
        </button>
        <p className="text-xs text-mr-muted pb-2">{busy === "photo_file_id" ? "Envoi de la photo…" : "Touchez la photo ou la couverture pour la changer."}</p>
      </div>
      <input ref={photoRef} type="file" accept="image/*" className="hidden" data-testid="profile-photo-input" onChange={(e) => pick("photo_file_id", e.target.files[0])} />
      <input ref={coverRef} type="file" accept="image/*" className="hidden" data-testid="profile-cover-input" onChange={(e) => pick("cover_file_id", e.target.files[0])} />
    </div>
  );
}
